import { Entity } from '@data-client/rest';
export class StringKeyValuePairEntity extends Entity {
    constructor() {
        super(...arguments);
        this.key = null;
        this.value = null;
    }
    pk() {
        var _a;
        return `${this.constructor.key}:${(_a = this.key) !== null && _a !== void 0 ? _a : ''}`;
    }
}
class EncryptionsAccessLogClientTypeEntity extends StringKeyValuePairEntity {
}
EncryptionsAccessLogClientTypeEntity.key = 'EncryptionsAccessLogClientType';
export { EncryptionsAccessLogClientTypeEntity };
class EncryptionsAccessLogDetailTypeEntity extends StringKeyValuePairEntity {
}
EncryptionsAccessLogDetailTypeEntity.key = 'EncryptionsAccessLogDetailType';
export { EncryptionsAccessLogDetailTypeEntity };
class EncryptionsAccessLogEventTypeEntity extends StringKeyValuePairEntity {
}
EncryptionsAccessLogEventTypeEntity.key = 'EncryptionsAccessLogEventType';
export { EncryptionsAccessLogEventTypeEntity };
